var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.5,7.5c0,1.4-1.1,2.5-2.5,2.5s-2.5-1.1-2.5-2.5S15.6,5,17,5S19.5,6.1,19.5,7.5z M20.5,7.5 c0,1.2-0.6,2.2-1.4,2.8c2.8,0.9,4.9,3.5,4.9,6.7c0,0.3-0.2,0.5-0.5,0.5S23,17.3,23,17c0-3.3-2.7-6-6-6c-1.6,0-3.1,0.6-4.2,1.7 c-0.2,0.2-0.5,0.2-0.7,0c-0.2-0.2-0.2-0.5,0-0.7c0.8-0.7,1.7-1.3,2.8-1.6c-0.9-0.6-1.4-1.7-1.4-2.8C13.5,5.6,15.1,4,17,4 S20.5,5.6,20.5,7.5z M10.5,9c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S10.5,7.3,10.5,9z M9.7,12.3c1.1-0.7,1.8-1.9,1.8-3.3 c0-2.2-1.8-4-4-4c-2.2,0-4,1.8-4,4c0,1.4,0.7,2.6,1.8,3.3C2.2,13.3,0,16.1,0,19.5C0,19.8,0.2,20,0.5,20C0.8,20,1,19.8,1,19.5 C1,15.9,3.9,13,7.5,13c3.6,0,6.5,2.9,6.5,6.5c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5C15,16.1,12.8,13.3,9.7,12.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers);
export default __webpack_public_path__ + "static/media/icon-users.6952969a1f4dbb5080c4f0c8d0316807.svg";
export { ForwardRef as ReactComponent };